<template>
  <v-dialog max-width="900px" :value="value" @input="toggleModal(true)">
    <v-card>
      <v-toolbar color="kbLightBlue" dark flat>
        <v-toolbar-title class="text-h6">
          {{ isExtraDataSelected ? $t('general.extraCreatorEditField') : $t('general.extraCreatorCreateField') }}
        </v-toolbar-title>

        <v-spacer/>

        <v-btn @click="toggleModal(true)"
               icon>
          <v-icon>
            clear
          </v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form ref="extraDataForm">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field color="kbDarkBlue"
                            label="Ingresa el nombre del dato adicional"
                            :rules="[rules.required]"
                            v-model="extraDataForm.name"/>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select color="kbDarkBlue"
                        :items="fieldTypeOptions"
                        item-value="type"
                        :prepend-inner-icon="selectedIcon"
                        :rules="[rules.required]"
                        v-model="extraDataForm.type">
                <template v-slot:item="{ item }">
                  <div class="d-flex align-center">
                    <v-icon class="mr-2" color="kbDarkBlue">{{ item.icon }}</v-icon>
                    <span class="kbDarkBlue--text">{{ item.text }}</span>
                  </div>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-form>

        <v-form ref="extraDataOptions"
                v-if="extraDataForm.type === 'select' ||
                      extraDataForm.type === 'radio' ||
                      extraDataForm.type === 'checkbox'">
          <v-row>
            <v-col cols="12">
              <v-text-field color="kbDarkBlue"
                            class="text-capitalize"
                            label="Añade una nueva opción"
                            :rules="[rules.required]"
                            v-model="newOption"
                            @keyup.enter="addNewOption()">
                <template v-slot:append-outer>
                  <v-btn color="kbDarkBlue" icon @click="addNewOption()">
                    <v-icon size="28px">mdi-plus-circle</v-icon>
                  </v-btn>
                </template>
              </v-text-field>

              <template v-if="extraDataForm.options.length > 0">
                <v-text-field color="kbDarkBlue"
                              class="text-capitalize"
                              v-for="(option, index) in extraDataForm.options"
                              v-model="option.name"
                              :key="index">
                  <template v-slot:append-outer>
                    <v-btn color="red" icon @click="removeOption(index)">
                      <v-icon size="28px">mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </template>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="d-flex justify-end">
        <v-btn class="mr-2"
               color="kbRed"
               outlined
               @click="toggleModal(true)">
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn color="kbLightBlue" dark :loading="loadingSubmitExtraData" @click="submit()">
          {{  isExtraDataSelected ? $t('general.edit') : $t('general.add') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      selectedJourney: state => state.journey.selectedJourney
    }),
    isExtraDataSelected () {
      return typeof this.selectedExtraData === 'object' && Object.keys(this.selectedExtraData).length > 0
    },
    fieldTypeOptions () {
      return [
        { icon: 'short_text', text: this.$t('general.extraCreatorShortText'), type: 'text' },
        { icon: 'mdi-text-subject', text: this.$t('general.extraCreatorLongText'), type: 'textLong' },
        { icon: 'mdi-radiobox-marked', text: this.$t('general.extraCreatorRadioList'), type: 'radio' },
        { icon: 'mdi-checkbox-marked', text: this.$t('general.extraCreatorCheckList'), type: 'checkbox' },
        { icon: 'arrow_drop_down_circle', text: this.$t('general.extraCreatorList'), type: 'select' }
      ]
    },
    selectedIcon () {
      return this.fieldTypeOptions.find(item => item.type === this.extraDataForm.type).icon
    }
  },
  data () {
    return {
      extraDataForm: {
        name: '',
        type: 'text',
        options: [],
        access: 'private'
      },
      loadingSubmitExtraData: false,
      newOption: '',
      rules
    }
  },
  methods: {
    addNewOption () {
      if (!this.$refs.extraDataOptions.validate()) return
      const foundOption = this.extraDataForm.options.find(item => item.name.toLowerCase() === this.newOption.toLowerCase())
      if (foundOption) return notifications.error('Ya existe una opción con el mismo nombre')
      let optionId = 0
      if (this.extraDataForm.options.length > 0) {
        optionId = parseInt(Math.max(this.extraDataForm.options.map(item => item.id))) + 1
      }
      this.extraDataForm.options.push({ name: this.newOption, id: optionId })
      this.newOption = ''
    },
    clearExtraDataForm () {
      this.extraDataForm = {
        name: '',
        type: 'text',
        options: [],
        access: 'private'
      }
      this.newOption = ''
    },
    async createNewExtraData () {
      let { extradata, ...all } = this.selectedJourney
      if (!extradata || !Array.isArray(extradata)) {
        extradata = []
      }
      if (extradata.find(item => item.name.toLowerCase() === this.extraDataForm.name.toLowerCase())) {
        return notifications.error('Ya existe un dato adicional con el mismo nombre')
      }
      if (extradata.length === 0) this.$set(this.extraDataForm, 'id', 0)
      else {
        const maxId = Math.max(...extradata.map(item => parseInt(item.id)))
        this.$set(this.extraDataForm, 'id', parseInt(maxId) + 1)
      }
      extradata.push({ ...this.extraDataForm })
      this.loadingSubmitExtraData = true
      try {
        const data = { extradata, replaceVal: false, ...all }
        await this.$store.dispatch('updateJourney', { journeyId: this.$route.params.journeyId, data })
        await this.$store.dispatch('getJourney', {
          companyId: this.$route.params.companyid,
          appId: this.$route.params.appid,
          journeyId: this.$route.params.journeyId
        })
        this.loadingSubmitExtraData = false
        notifications.success('Dato adicional agregado correctamente')
        this.toggleModal()
      } catch (e) {
        this.loadingSubmitExtraData = false
        notifications.error(e)
        throw e
      }
    },
    removeOption (index) {
      this.extraDataForm.options.splice(index, 1)
    },
    setExtraDataForm () {
      this.extraDataForm = { ...this.selectedExtraData }
    },
    submit () {
      if (!this.$refs.extraDataForm.validate()) return
      if (this.loadingSubmitExtraData) return
      this.isExtraDataSelected ? this.updateExtraData() : this.createNewExtraData()
    },
    toggleModal (closingWithoutUpdate = false) {
      if (closingWithoutUpdate) {
        this.$store.dispatch('getJourney', {
          companyId: this.$route.params.companyid,
          appId: this.$route.params.appid,
          journeyId: this.$route.params.journeyId
        })
      }
      this.$emit('input', false)
    },
    async updateExtraData () {
      const { extradata, ...all } = this.selectedJourney
      const foundExtraData = extradata.find(item => item.name.toLowerCase() === this.extraDataForm.name.toLowerCase())
      if (foundExtraData && parseInt(this.extraDataForm.id) !== parseInt(foundExtraData.id)) {
        return notifications.error('Ya existe un dato adicional con el mismo nombre')
      }
      this.loadingSubmitExtraData = true
      const extraDataToUpdateIndex = extradata.map(item => item.id).indexOf(this.extraDataForm.id)
      if (extraDataToUpdateIndex === -1) return notifications.error('No se encontro el index del extraData a editar')
      extradata[extraDataToUpdateIndex] = { ...this.extraDataForm }
      try {
        const data = { extradata, replaceVal: false, ...all }
        await this.$store.dispatch('updateJourney', { journeyId: this.$route.params.journeyId, data })
        await this.$store.dispatch('getJourney', {
          companyId: this.$route.params.companyid,
          appId: this.$route.params.appid,
          journeyId: this.$route.params.journeyId
        })
        this.loadingSubmitExtraData = false
        notifications.success('Dato adicional editado correctamente')
        this.toggleModal()
      } catch (e) {
        this.loadingSubmitExtraData = false
        notifications.error(e)
        throw e
      }
    }
  },
  props: {
    selectedExtraData: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Boolean
    }
  },
  watch: {
    value (newValue) {
      if (!newValue) return this.clearExtraDataForm()
      if (Object.keys(this.selectedExtraData).length > 0) {
        this.setExtraDataForm()
      }
    }
  }
}
</script>
